import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatClientes from '../../../Interfaces/Catalogos/ICatClientes'
const CatClientes: ICatClientes[] = []
const initialState = { CatClientes }

export const CatClientesSlice = createSlice({
  name: 'CatClientes',
  initialState: initialState,
  reducers: {
    resetCatClientes : (state, action: PayloadAction<string>) => {
      state.CatClientes =  []
    },  
    populateCatClientes : (state, action: PayloadAction<ICatClientes[]>) => {
        action.payload.forEach(element => {
            const index = state.CatClientes.findIndex(object => object.id === element.id)
            if (index<0) state.CatClientes.push(element)
        })
    },
    updateCatClientes : (state, action: PayloadAction<ICatClientes>) => {
      const i = state.CatClientes.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatClientes[i] = action.payload;
      else state.CatClientes.push(action.payload);
    },
    deleteCatClientes : (state, action: PayloadAction<number>) => {
      const newArr = state.CatClientes.filter(data => data.id != action.payload);
      state.CatClientes=newArr
    },
  },
})

export const { resetCatClientes, populateCatClientes, updateCatClientes, deleteCatClientes } = CatClientesSlice.actions;
export default CatClientesSlice.reducer;